import { useState, useEffect } from "react";
import Hero from "@/components/sections/Hero";
import Marquee from "@/components/sections/Marquee";
import Duality from "@/components/sections/Duality";
import ProductShowcase from "@/components/sections/ProductShowcase";
import Manifesto from "@/components/sections/Manifesto";
import Services from "@/components/sections/Services";
import Testimonials from "@/components/sections/Testimonials";
import BlogPreview from "@/components/sections/BlogPreview";
import CTA from "@/components/sections/CTA";

export default function Home() {
  const [started, setStarted] = useState(false);

  useEffect(() => {
    setStarted(true);
  }, []);

  return (
    <div data-testid="home-page">
      <Hero start={started} />
      <Marquee />
      <Duality />
      <ProductShowcase />
      <Manifesto />
      <Services />
      <Testimonials />
      <BlogPreview />
      <CTA />
    </div>
  );
}
